import Box, { type BoxProps } from '@mui/material/Box';
import DOMPurify from 'dompurify';
import type { HTMLAttributes } from 'react';

type HTMLViewProps = Omit<BoxProps, 'children'> &
  HTMLAttributes<HTMLDivElement> & {
    children?: string;
  };

function HTMLView(props: HTMLViewProps) {
  const { children = '', ...restProps } = props;
  const sanitized = DOMPurify.sanitize(children);

  return (
    <Box
      dangerouslySetInnerHTML={{ __html: sanitized }}
      {...restProps}
      sx={{ ...restProps?.sx, width: '100%' }}
    />
  );
}

export type { HTMLViewProps };
export { HTMLView };
